import { cn as baseCn } from "@netlify/ui";

/**
 * A simple JavaScript utility for conditionally joining classNames together. A convenient re-export
 * of the popular classnames package.
 *
 * @see {@link <a href="https://www.npmjs.com/package/classnames" target="_blank" rel="noopener noreferrer">classnames - npm package</a>}
 */
export const cn = baseCn;
